import { Directive } from '@angular/core';
import { ArrayHelpers } from '../../../../helpers/array.helpers';
import { MediaService } from '../../../../services/media.service';
import { BaseSchedulerControl } from '../base.scheduler.control';

export abstract class BaseTriggerControl extends BaseSchedulerControl {
}

// @dynamic
@Directive()
export abstract class MediaSourceTriggerControl extends BaseTriggerControl {
    MediaSources = [];

    constructor(private service: MediaService) {
        super();
    }

    ngOnInit(): void {
        this.service.Get().subscribe(x => {
            if (x) {
                ArrayHelpers.sortAlphabetical(x, 'Caption');
                this.MediaSources = x;
            }
        });
    }
}